import React from 'react';

import { useQuery } from "react-query";

import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';

import { fetchPieceGestionDossiers} from 'utils/ts-queries';
import { ApiPieceGestionDossiers } from 'types/apiReturns';


import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';


import Datetime from 'components/Shared/Datetime';

import { ReclamationStatut } from 'constants.js';
import { ReclamationStatuts } from 'constants.js';

type Props = {
    piece: any;
    onClickCreate:  (x: any) => any
};
export default function DossiersPiece({ piece, onClickCreate }: Props) {

    const numeroPiece = piece.numeroPiece;
    // Clé technique pour les appels API (BL ou DT) — fallback sur numeroPiece pour le legacy
    const cleApi = piece.bonLivraisonGestionCle || piece.demandeTransfertGestionCle || numeroPiece;

    const { isLoading, isError, data } =
        useQuery({
            queryKey: [
                'DossiersPiece',
                cleApi
            ],
            queryFn: () => fetchPieceGestionDossiers(cleApi),
            keepPreviousData: true,
        })


    if(isLoading){
        return (<Paper sx={{marginLeft:2, marginRight:2, marginBottom:2}}>Chargement en cours</Paper>);
    }   
    if(isError){
        return (<Paper sx={{marginLeft:2, marginRight:2, marginBottom:2}}>Erreur de récupération des données</Paper>);
    }    

    if(!data){
        return (<Paper sx={{marginLeft:2, marginRight:2, marginBottom:2}}>Aucune donnée</Paper>);
    }
    
    const infosLogistiques = {
        numeroPiece: numeroPiece,
        pieceCle: cleApi !== numeroPiece ? cleApi : null,
        typePiece: data.typePiece,
        client: data.client ? {
            ...data.client
        } : null
    };

    return (
        <Paper sx={{marginLeft:2, marginRight:2, marginBottom:2}}>


            <Stack m={1} spacing={1} direction={"row"} sx={{ alignItems: "start" }}>

                <Typography variant='body1' sx={{flexGrow: 1}}>
                    Vous avez selectionné la pièce <span style={{fontWeight: 'bold'}}>{numeroPiece}</span>{data.client && <> pour le client <span style={{fontWeight: 'bold'}}>{data.client.code} - {data.client.libelle}</span></>}
                </Typography> 

                {data.nouveauDossier.message && (
                    <Tooltip title={data.nouveauDossier.message}>
                        <span>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => onClickCreate(infosLogistiques)}
                                disabled={!data.nouveauDossier.autorise}
                            >
                                Créer un dossier depuis la pièce sélectionnée
                            </Button>
                        </span>
                    </Tooltip>
                )}

                {!data.nouveauDossier.message && (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => onClickCreate(infosLogistiques)}
                        disabled={!data.nouveauDossier.autorise}
                        sx={{marginBottom: 2}}
                    >
                        Créer un dossier depuis la pièce sélectionnée
                    </Button>
                )}


                </Stack> 

            <>
            
                {data.reclamations.length > 0 && (                        
                    <TableContainer component={Paper} sx={{  maxHeight: '100%' }} >
                        <Table size="small"  stickyHeader >
                            <TableHead>
                                <TableRow>
                                    <TableCell>Dossier</TableCell>
                                    <TableCell>Catégorie</TableCell>
                                    <TableCell>Qualification</TableCell>
                                    <TableCell>Émetteur</TableCell>
                                    <TableCell sx={{ whiteSpace: 'nowrap' }}>Date création</TableCell>
                                    <TableCell>Statut</TableCell>
                                    <TableCell sx={{ whiteSpace: 'nowrap' }}>Avoir généré</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.reclamations.sort((a,b) => a.statut === b.statut ? b.id -a.id : a.statut - b.statut).map((reclamation) => (
                                    <TableRow
                                        key={reclamation.id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            <Link
                                                to={`/reclamations/${reclamation.id}`}
                                                underline="hover"
                                                component={RouterLink}
                                                sx={{ fontWeight: 'bold' }}
                                            >
                                                {reclamation.id}
                                            </Link>
                                        </TableCell>
                                        <TableCell>{reclamation.categorie.libelle}</TableCell>
                                        <TableCell>{reclamation.qualification.libelle}</TableCell>
                                        <TableCell>{reclamation.emetteur.nom}</TableCell>
                                        <TableCell>
                                            <Datetime datetime={reclamation.dateCreation} withTooltip />
                                        </TableCell>
                                        <TableCell>{ReclamationStatuts[reclamation.statut]}</TableCell>
                                        <TableCell>{reclamation.avoirGenere}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                
                {data.reclamations.length === 0 && (
                    <Typography variant='body1' sx={{margin: 1}}>
                        Aucun dossier sur cette pièce
                    </Typography>
                )}
            </>
            
        </Paper>
    );
}
